module.exports = __webpack_public_path__ + "img/close-icon.02ae8803.svg";